module.exports = " <div> <div class=nav> <a v-link=\"'/home'\">Home</a> <a v-link=\"'/hello'\">Hello</a> </div> <router-view class=view keep-alive transition transition-mode=out-in> </router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 7
// module chunks = 0